import { useTranslation } from "react-i18next";

export function TransportCompanyAssignmentFallback() {
  const { t } = useTranslation(["fit"]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <div className="text-center">
        <p className="text-lg font-medium">{t("fit:NoTransportCompaniesAssigned")}</p>
        <p className="text-muted-foreground mt-2 text-sm">{t("fit:YouNeedTransportCompanyAssignmentToUseThisPage")}</p>
        <p className="text-muted-foreground text-sm">{t("fit:ContactAlphanetAdmins")}</p>
      </div>
    </div>
  );
}
